import React, { createContext, useContext, useState } from 'react';

// Maximum number of messages to keep in memory to prevent memory leaks
// Older messages will be automatically removed when this limit is exceeded
const MAX_MESSAGES = 100;

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const addMessage = (message) => {
    // Add new message and limit array size to prevent memory leaks
    // Keep newest messages by removing oldest when limit exceeded
    setMessages(prev => [...prev, message].slice(-MAX_MESSAGES));
    setUnreadCount(prev => prev + 1);
  };

  const clearMessage = (threadId) => {
    setMessages(prev => prev.filter(m => m.threadId !== threadId));
    setUnreadCount(prev => Math.max(0, prev - 1));
  };

  const clearAllMessages = () => {
    setMessages([]);
    setUnreadCount(0);
  };

  return (
    <MessageContext.Provider 
      value={{ 
        messages, 
        unreadCount, 
        addMessage, 
        clearMessage,
        clearAllMessages 
      }}
    >
      {children}
    </MessageContext.Provider>
  );
};

export const useMessages = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error('useMessages must be used within a MessageProvider');
  }
  return context;
}; 